import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-enter-email',
    templateUrl: './enter-email.component.html',
    standalone: false
})
export class EnterEmailComponent implements OnInit {
  email = '';
  constructor(private dialogRef: MatDialogRef<EnterEmailComponent>) { }

  ngOnInit(): void {
  }

  onSubmit() {
    this.dialogRef.close(this.email);
  }

  cancel() {
    this.dialogRef.close();
  }
}
